import { gql } from "@apollo/client";

export const createApiIntegration = gql`
  mutation Mutation($input: CreateOrUpdateApiIntegrationInput!) {
    createOrUpdateApiIntegration(input: $input) {
      id
      isLive
      publicKeyTest
      secretKeyTest
      encryptionKeyTest
      publicKeyLive
      secretKeyLive
      encryptionKeyLive
      meta
      organizationId
      createdAt
      updatedAt
    }
  }
`;
